import ReportDom from "../../../../../components/common/ReportDom";
import PurchaseVoucherBody from "./PurchaseVoucherBody";

export default function PurchasePrint({ id }) {
  return (
    <ReportDom
      renderTable={() => <PurchaseVoucherBody pur_id={id} printMode />}
    />
  );
}
